import React from 'react';
import styles from '@/components/PageHeader/styles/mobileNavBar.module.scss';
import { PageHeaderMenuItem } from '@/components/PageHeader/PageHeader.model';

/**
 * Renders a product document page as a list item.
 * @param productDocumentPage - The product document page data.
 * @param productDocumentPageIndex - The index of the product document page.
 * @returns JSX.Element
 */
export function renderProductDocumentPage(
  productDocumentPage: PageHeaderMenuItem,
  productDocumentPageIndex: number
): JSX.Element {
  return (
    <li className={styles.greatGrandSubMenu} key={productDocumentPageIndex}>
      <a className={styles.nested} href={productDocumentPage.url || '#'}>
        {productDocumentPage.value}
      </a>
    </li>
  );
}